import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["disabledField"];

  onSelect(event) {
    const {
      target: { value: selected, dataset },
    } = event;
    const disableValuesOptions = JSON.parse(dataset.disableonselectedis);
    const enableField = disableValuesOptions.includes(parseInt(selected));
    this.toggleReadOnlyField(enableField);
  }

  toggleReadOnlyField(enableField) {
    const targetAttribute = this.disabledFieldTarget;

    if (enableField) {
      targetAttribute.removeAttribute("readonly");
    } else {
      targetAttribute.setAttribute("readonly", true);
    }
  }
}
